/**
 * Parking Detail Modal (Web)
 * 
 * Utilizes `ParkingDetailModalCommon` for shared functionality while importing the appropriate
 * FontAwesome library for web usage.
 * 
 * @file ParkingDetailModal.web.js
 */
import React from 'react';
import { useNavigation } from '@react-navigation/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ParkingDetailModalCommon from './ParkingDetailModalCommon';

const ParkingDetailModal = ({ route }) => {
    const navigation = useNavigation();
    return (
        <ParkingDetailModalCommon
            route={route}
            navigation={navigation}
            FontAwesomeIcon={FontAwesomeIcon}
            closeBtnSize="2xl"
            iconSize="lg"
        />
    );
};

export default ParkingDetailModal;
